import React from 'react';
import { CUSTOM_PROJECTS_ID } from '../constants';

export interface LogoProps {
  showLogo?: boolean;
  projectId?: string;
  margin?: number;
  customUrl?: string;
  fallbackSrc?: string;
  className?: string;
  imgClassName?: string;
}

export const Logo = React.memo(function Logo({
  showLogo,
  projectId,
  margin,
  customUrl,
  fallbackSrc,
  className = 'header-logo',
  imgClassName,
}: LogoProps) {
  if (!showLogo) return null;
  const isCustomProject =
    !!projectId && Object.values(CUSTOM_PROJECTS_ID).includes(projectId);

  return (
    <div className={className} style={{ margin }}>
      {/* staging */}
      {projectId === CUSTOM_PROJECTS_ID.hkinvest_staging && (
        <img height="55" alt="FintechHK" src="/clients/FintechHK_logo.png" />
      )}
      {projectId === CUSTOM_PROJECTS_ID.directassurance && (
        <img
          height="55"
          alt="Direct Assurance"
          src="/clients/logo-direct-assurance.webp"
        />
      )}
      {/* production */}
      {projectId === CUSTOM_PROJECTS_ID.monolith && (
        <img height="50" alt="Monolith" src="/clients/monolith.png" />
      )}
      {!isCustomProject && customUrl && (
        <img
          src={customUrl}
          style={{ margin }}
          alt={''}
          className={imgClassName}
        />
      )}
      {!isCustomProject && !customUrl && fallbackSrc && (
        <img
          src={fallbackSrc}
          style={{ margin }}
          alt="Libertify"
          className={imgClassName}
        />
      )}
    </div>
  );
});
